import axios from 'axios';

export function sendTimingLog(entry) {
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    const access   = userData?.access ?? null;
    if (!access) return;

    axios.post(
        process.env.REACT_APP_BACK_API_URL + 'api-interna/log_timing',
        entry,
        { headers: { 'Authorization': `Bearer ${access}` } }
    ).catch(() => {});  // fire-and-forget, nunca bloquea el flujo principal
}
